import { Tag, Wrapper } from '@visualfabriq/vf-ui-kit';

export function TagsColumn({ tags }: { tags: string[] | null }) {
  const validTags = (tags ?? []).filter((tag): tag is string => typeof tag === 'string');

  if (validTags.length === 0) return null;

  return (
    <Wrapper wrap="nowrap" alignItems="baseline">
      {validTags.map((tag) => (
        <Tag key={tag} color="blue" size="small">
          {tag}
        </Tag>
      ))}
    </Wrapper>
  );
}
